<template>
  <div>
    <loading :active.sync="isLoading"
             :can-cancel="false"
             color="#007BFF"
             :is-full-page="true">
    </loading>
    <base-header class="pb-6"> </base-header>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header border-0">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">Feedback</h3>
            </div>
          </div>
        </div>
        <div class="row starter-page">
          <div class="container-fluid ">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <div class="d-inline-block pr-2">
                  <base-button type="success" @click="downloadExcel"><i class="ni ni-cloud-download-95"></i> Excel</base-button>
                </div>
                <div class="d-inline-block">
                  <el-select
                    class="select-primary pagination-select"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="d-inline-block pl-2">
                  <base-input addon-left-icon="ni ni-calendar-grid-58">
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="dates.config"
                      class="form-control datepicker"
                      @input="dateRangeChange"
                      v-model="dates.range"
                      placeholder="Seleccione fecha"
                    >
                    </flat-picker>
                  </base-input>
                </div>
              </div>
              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Buscar..."
                >
                </base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>
            </el-table>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="">
                <p class="card-category">
                  Mostrando {{ from + 1 }} to {{ to }} de {{ total }} registros

                  <span v-if="selectedRows.length">
                    &nbsp; &nbsp; {{ selectedRows.length }} fila seleccionada
                  </span>
                </p>
              </div>
              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              >
              </base-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment'
import { Table, TableColumn, Select, Option } from "element-ui";
import { mapActions, mapState, mapMutations } from "vuex";
import feedbackPaginationMixin from "../../mixin/feedbackPaginationMixin";
import flatPicker from "vue-flatpickr-component";
import { Spanish } from "flatpickr/dist/l10n/es";
  import Loading from 'vue-loading-overlay';
export default {
  name: "ListFeedback",
  mixins: [feedbackPaginationMixin],
  components: {
    // BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    flatPicker,
    Loading
  },
  data() {
    return {
      isLoading: false,
      selectedRows: [],
      propsToSearch: ["client", "order_qualification", "item"],
      tableColumns: [
        {
          prop: "client",
          label: "Nombre",
          minWidth: 200,
          sortable: true
        },
        {
          prop: "order_qualification",
          label: "Estrella",
          minWidth: 150,
          sortable: true
        },
        {
          prop: "observation",
          label: "Comentario",
          minWidth: 220,
          sortable: true
        },
        {
          prop: "date",
          label: "Fecha",
          minWidth: 150,
          sortable: true
        }
      ],
      tableData: [],
      dates: {
        range: "",
        config: { allowInput: false, mode: "range", locale: Spanish }
      },
      rangeDate: []
    };
  },
  created() {},
  computed: {
    ...mapState("feedback", ["feedbacks"])
  },
  methods: {
    ...mapActions("feedback", ["GET_FEEDBACKS"]),
    ...mapMutations("feedback", ["SET_FEEDBACKS"]),
    async downloadExcel() {
        this.isLoading = true;
        const endpoint = process.env.VUE_APP_API_CATERINGV2;
        await axios({
          url: `${endpoint}/feedbacks/export`,
          method: 'get',
          responseType: 'blob', // important
          params: { dates: this.rangeDate}
        }).then((response) => {
          this.isLoading = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'feedbacks-' + moment(new Date()).format("YYYY-MM-DD HH:mm:ss") + '.xlsx');
          document.body.appendChild(link);
          link.click();
        })
          .catch(error => {
            console.log(error)
          });
      },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    dateRangeChange(val) {
      const dates = val.split("a").map(item => {
        return item.trim();
      });
      dates.length === 2 ? (this.rangeDate = dates) : "";
    }
  },
  watch: {
    rangeDate(val) {
      this.SET_FEEDBACKS([]);
      this.GET_FEEDBACKS({
        dates: val
      });
    }
  }
};
</script>

<style scoped></style>
